import SecureLayout from "../../../components/layouts/secure-layout";
import { t } from "../../../translate";
import CreateRequest from "../../request/create-request";

const AddRequestsAndOffers = () => {
    return (
        <SecureLayout
            onlyHeader
            activePage={"requests-and-offers"}
            role={"customer"}
            title={t("requests-and-offers.add.title")}
            description={t("requests-and-offers.add.desceription")}
        >
            <CreateRequest />
        </SecureLayout>
    );
};

export default AddRequestsAndOffers;
